<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-4 flex flex-col gap-5 bg-[#FFFFFF] rounded-[16px] font-[Gilroy]">
            <div class="flex w-full gap-4 mobile:gap-1 justify-between items-center">
                <p class="text-black font-semibold text-2xl mobile:text-md">{{
                    'locations.confirm_location_delete' | transloco }}
                </p>
                <button (click)="closeModal()" title="{{ 'shared.close' | transloco }}"><img
                        src="assets/icons/close-circle-black.svg" alt="X"></button>
            </div>
            <p class="text-neutral-800">{{
                'locations.warning_location_delete' | transloco }}</p>
            <ul class="list-disc pl-5">
                <li>
                    <p class="text-neutral-800">{{
                        'locations.all_consumption_history' | transloco }}</p>
                </li>
                <li>
                    <p class="text-neutral-800">{{
                        'locations.energy_usage_patterns' | transloco }}</p>
                </li>
                <li>
                    <p class="text-neutral-800">{{
                        'locations.custom_reports_settings' | transloco }}</p>
                </li>
            </ul>

            <div class="w-full h-[50px]">
                <app-custom-button buttonText="{{ 'locations.delete_location' | transloco }}" [isDisabled]="false"
                    backgroundColor="bg-error" textColor="text-white" fontWeight="font-bold" borderColor="border-error"
                    hoverBackgroundColor="hover:bg-error-800" hoverBorderColor="hover:border-error-800"
                    (click)="deleteLocation()" [isDisabled]="deleteClicked">
                </app-custom-button>
            </div>

            <div *ngIf="dialogErrorMessage" class="flex items-center text-error mt-2 text-sm">
                <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
                    class="w-5 h-5" />
                <p class="ml-1">{{ dialogErrorMessage }}</p>
            </div>
        </div>

    </ng-template></p-dialog>